import { Avatar, UnstyledButton, UnstyledButtonProps } from '@mantine/core';
import { forwardRef } from 'react';
import Avvvatars from 'avvvatars-react';
import { User } from 'api/user';

interface UserAvatarProps extends UnstyledButtonProps {
  user: User;
  size?: number;
  /**
   * Renders as something other than a button. Needed wherever the avatar sits
   * inside another interactive element (nested buttons are invalid HTML).
   */
  component?: any;
}

export const UserAvatar = forwardRef<HTMLButtonElement, UserAvatarProps>(
  ({ user, size = 40, ...props }: UserAvatarProps, ref) => {
    return (
      <UnstyledButton ref={ref} {...props}>
        {user?.avatarUrl ? (
          <Avatar radius="50%" src={user.avatarUrl} size={size} />
        ) : user?.firstName ? (
          <Avvvatars value={user?.firstName} size={size} />
        ) : (
          <Avatar color="teal" radius="50%" size={size} />
        )}
      </UnstyledButton>
    );
  }
);
